<script>
import { getCredibleReport } from "@/api/api";
import iconA from './icons/A.vue'
import iconStarFill from './icons/StarFill.vue'
import iconStarLine from './icons/StarLine.vue'
import imgCode from "@/components/validateImageCode.vue";
import Watermark from '@/assets/waterMarker'
import html2pdf from '@/utils/html2pdf'
const fieldList = [
  {
    title: "经营实体信息",
    fields: [
      {
        label: '基地名称',
        column: 'cname',
        show: ['base'],
      }, {
        label: '机构名称',
        column: 'cname',
        show: ['org'],
      }, {
        label: '所属公司名称',
        column: 'gs',
        show: ['base', 'org'],
      }, {
        label: '法人代表',
        column: 'fr',
        show: ['base', 'org'],
      }, {
        label: '联系电话',
        column: 'tel',
        show: ['base', 'org'],
      }, {
        label: '注册资本',
        column: 'zb',
        show: ['base', 'org'],
      }, {
        label: '社会信用代码',
        column: 'cc',
        show: ['base', 'org'],
      }, {
        label: '基地地址',
        column: 'adderss',
        show: ['base', 'org'],
      },
    ]
  }, {
    title: "信用认证信息",
    fields: [
      {
        label: '基地运营状态',
        column: 'state',
        show: ['base'],
      }, {
        label: '机构运营状态',
        column: 'state',
        show: ['org'],
      }, {
        label: '基地级别',
        column: 'clevel',
        show: ['base'],
      }, {
        label: '基地公众责任险状态',
        column: 'credit_state',
        show: ['base'],
      }, {
        label: '机构公众责任险状态',
        column: 'credit_state',
        show: ['org'],
      }, {
        label: '上年度研学接待量',
        column: 'pmun',
        show: ['base', 'org'],
      }, {
        label: '本年度研学接待量',
        column: 'amun',
        show: ['base', 'org'],
      }, {
        label: '研学课程数量',
        column: 'smun',
        show: ['base'],
      }, {
        label: '研学方案数量',
        column: 'smun',
        show: ['org'],
      }, {
        label: '研学基地热度排名(全省)',
        column: 'row_number',
        show: ['base'],
      }, {
        label: '研学机构热度排名(全省)',
        column: 'row_number',
        show: ['org'],
      },
    ]
  }
]

export default {
  // 可信报告
  name: "credibleReport",
  components: {
    imgCode,
    iconA,
    iconStarFill,
    iconStarLine
  },
  props: {
    navText: {
      type: String,
      default: ''
    },
  },
  computed: {
    codeIsValid() {
      const code = this.code?.toLowerCase();
      const codeInput = this.codeInput?.toLowerCase();
      return code && codeInput === code
    },
    currentDate() {
      const date = new Date();
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },
    showType() {
      switch (this.navText) {
        case '基地可信报告':
          return 'base'
        case '机构可信报告':
          return 'org'
        default:
          return ''
      }
    },
    levelLength() {
      return this.reportData?.xyleve?.length || 0
    }
  },
  data() {
    return {
      cname: '',
      code: '',
      codeInput: "",
      showReport: false,
      onSearch: false,
      reportData: null,
      fieldList: fieldList
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toPdf() {
      html2pdf(this.$refs?.reportBox, `研学${this.navText}`, this.currentDate)
    },
    clear() {
      this.codeInput = '';
      this.cname = '';
      this.showReport = false;
      Watermark.clear()
      this.$emit('cancel')
    },
    toSearch() {
      if (!this.codeInput) {
        return alert('请输入验证码!')
      }
      if (!this.codeIsValid) {
        return alert("验证码错误!")
      }
      this.codeInput = ''
      getCredibleReport(
        this.navText, this.cname
      ).then((res) => {
        if (res.state === "SUCCESS") {
          if (res.data.length === 0) {
            alert('未查到相关数据');
            this.showReport = false;
          } else {
            this.reportData = res.data[0];
            this.showReport = true;
            this.$nextTick(() => {
              Watermark.set('陕西研学在线', this.$refs?.reportBox, this.currentDate)
            })
          }
        } else if (res?.resultMessage) {
          alert(res.resultMessage);
        }
      });
    },
  },
}
</script>

<template>
  <div v-if="navText && (navText.includes('基地') || navText.includes('机构'))">
    <div
      class="serach-box mt-5"
      v-if="showReport === false"
    >
      <div class="w-50 m-auto">
        <b-form-input
          v-model="cname"
          :placeholder="'请输入完整单位名称'"
        ></b-form-input>
      </div>
      <div class="w-50 mx-auto my-3 d-flex">
        <b-form-input
          v-model="codeInput"
          placeholder="输入图片中的字符"
        ></b-form-input>
        <img-code
          class="ml-1"
          @change="code = $event"
        ></img-code>
      </div>
      <div
        class="m-auto"
        style="width: 50%;"
      >
        <button
          type="button"
          :disabled="!cname || onSearch"
          class="btn btn-primary mt-3 w-25 mr-2"
          @click="toSearch"
        >
          确定
        </button>

        <button
          type="button"
          class="btn  mt-3 w-25"
          @click="codeInput = ''; cname = ''; $emit('cancel')"
        >
          返回
        </button>
      </div>
    </div>
    <div
      style="background-color: #ccc;padding: 40px"
      v-else-if="showReport === true && reportData"
    >
      <div
        class="report-box"
        ref="reportBox"
      >
        <div class="title">
          研学{{ navText }}
        </div>
        <div
          class="content"
          v-for="content in fieldList"
        >
          <div class="sub-title">
            {{ content.title }}
          </div>
          <div class="field-list">
            <div
              class="field-item"
              v-for="item in content.fields"
              v-if="showType && item.show.includes(showType)"
            >
              <div class="label">{{ item.label }}</div>
              <div class="value">{{ reportData[item.column] }}</div>
            </div>
          </div>
        </div>
        <div class="footer-box">
          <div class="footer-label">
            信用级别：
            <!-- <icon-a
              v-for="item in levelLength"
              color="#000"
              :size="30"
              :key="item"
            />
            <icon-a
              v-for="item in 5 - levelLength"
              :key="item"
              color="#fff"
              stroke="#999"
              :size="30"
            /> -->
            <icon-star-fill
              v-for="item in levelLength"
              color="#000"
              :size="30"
              :key="item"
            />
            <icon-star-line
              v-for="item in 5 - levelLength"
              :key="item"
              color="#fff"
              stroke="#999"
              :size="30"
            />
            <!-- {{ reportData.xyleve }} -->
          </div>
          <div class="seal">
            <div>陕西研学在线</div>
            <div>{{ currentDate }}</div>
          </div>
        </div>
      </div>
      <div style="width: 500px;margin: 0 auto;">
        <button
          type="button"
          class="btn bg-white  mt-3 w-25"
          @click="clear"
        >
          关闭
        </button>
        <button
          type="button"
          class="btn bg-blue ml-2 mt-3 w-25"
          @click="toPdf"
        >
          下载
        </button>
      </div>
    </div>
  </div>
  <!-- <div v-else>请在左侧选择可信报告类型</div> -->
</template>

<style scoped lang="scss">
.report-box {
  text-align: left;
  padding: 40px 100px 40px;
  border: 1px solid #000;
  border-radius: 2px;
  position: relative;
  background: #fff;
  width: 649px;
  // height: 978px;
  margin: 0 auto;

  .title {
    font-weight: 800;
    font-size: 30px;
    margin-bottom: 50px;
    text-align: center;
  }

  .content {
    margin-bottom: 30px;

    .sub-title {
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: 600;
    }

    .field-list {
      .field-item {
        display: flex;
        padding: 5px 0;

        .label {
          margin-right: 20px;
        }
      }
    }
  }

  .footer-box {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    min-height: 80px;
    position: relative;

    .footer-label {
      font-weight: bold;
      font-size: 30px;
      display: flex;
      align-items: center;
    }

    .seal {
      width: 150px;
      height: 150px;
      position: absolute;
      right: -60px;
      bottom: 0;
      background-image: url("../assets/sealbg.png");
      background-size: contain;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 18px;
      z-index: 2;
      font-weight: bold;
    }
  }
}

.bg-blue {
  background-color: #3670f7;
  color: #fff;
}
</style>